import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import ClassificacaoFiscal from "model/fiscal/ClassificacaoFiscal";
import { Checkbox } from "primereact/checkbox";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import ClassificacaoFiscalService from "service/fiscal/ClassificacaoFiscalService";

const classificacaoFiscalService = new ClassificacaoFiscalService();

export default function ClassificacaoFiscalCadastro() {
    const [classificacaoFiscal, setClassificacaoFiscal] = useState<ClassificacaoFiscal>(new ClassificacaoFiscal());
    const [erro, setErro] = useState("");

    function validar() {
        if (!classificacaoFiscal.codigoInterno) {
            setErro("Preencha o campo Código.");
            return false;
        }
        if (!classificacaoFiscal.descricao) {
            setErro("Preencha o campo Descrição.");
            return false;
        }
        if (!classificacaoFiscal.ncm) {
            setErro("Preencha o campo NCM.");
            return false;
        }
        if (!/^\d{8}$/.test(classificacaoFiscal.ncm)) {
            setErro("O NCM deve conter 8 dígitos.");
            return false;
        }
        setErro("");
        return true;
    }

    return (
        <BaseCadastro model={classificacaoFiscal} service={classificacaoFiscalService}
            setModel={(value: ClassificacaoFiscal) => setClassificacaoFiscal(value)}
            getNewModel={() => new ClassificacaoFiscal()} novoCadastro
            validar={validar} pathCadastro="/classificacaoFiscal" urlService="/classificacaoFiscal" tituloPagina="Classificação fiscal">
            <div className="row">
                <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">Classificação fiscal</label>
            </div>
            <div className="row">
                <div className="col-12 mb-3">
                    <Checkbox inputId="classificacaoFiscal-ativo" checked={classificacaoFiscal.ativa}
                        onChange={(e) => setClassificacaoFiscal({ ...classificacaoFiscal, ativa: !!e.checked })} />
                    <label htmlFor="classificacaoFiscal-ativo" style={{ marginLeft: 8 }}>Ativo</label>
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Código</Label>
                    <InputText value={classificacaoFiscal.codigoInterno ?? ""} maxLength={10}
                        onChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, codigoInterno: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>Descrição</Label>
                    <InputText value={classificacaoFiscal.descricao ?? ""} maxLength={250}
                        onChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, descricao: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label obrigatorio>NCM</Label>
                    <InputText value={classificacaoFiscal.ncm ?? ""} maxLength={8}
                        onChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, ncm: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>CEST</Label>
                    <InputText value={classificacaoFiscal.cest ?? ""} maxLength={7}
                        onChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, cest: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Alíquota IPI padrão</Label>
                    <InputNumber value={classificacaoFiscal.aliquotaIpiPadrao} useGrouping={false}
                        minFractionDigits={0} maxFractionDigits={4}
                        onValueChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, aliquotaIpiPadrao: e.value ?? null }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>CST IPI padrão</Label>
                    <InputText value={classificacaoFiscal.cstIpiPadrao ?? ""} maxLength={2}
                        onChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, cstIpiPadrao: e.target.value || null }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Código de enquadramento IPI padrão</Label>
                    <InputText value={classificacaoFiscal.codigoEnquadramentoIpiPadrao ?? ""} maxLength={3}
                        onChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, codigoEnquadramentoIpiPadrao: e.target.value || null }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>CST PIS padrão</Label>
                    <InputText value={classificacaoFiscal.cstPisPadrao ?? ""} maxLength={2}
                        onChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, cstPisPadrao: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Alíquota PIS padrão</Label>
                    <InputNumber value={classificacaoFiscal.aliquotaPisPadrao} useGrouping={false}
                        minFractionDigits={0} maxFractionDigits={4}
                        onValueChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, aliquotaPisPadrao: e.value ?? null }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>CST COFINS padrão</Label>
                    <InputText value={classificacaoFiscal.cstCofinsPadrao ?? ""} maxLength={2}
                        onChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, cstCofinsPadrao: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Alíquota COFINS padrão</Label>
                    <InputNumber value={classificacaoFiscal.aliquotaCofinsPadrao} useGrouping={false}
                        minFractionDigits={0} maxFractionDigits={4}
                        onValueChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, aliquotaCofinsPadrao: e.value ?? null }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>CST IBS/CBS padrão</Label>
                    <InputText value={classificacaoFiscal.cstIbsCbsPadrao ?? ""} maxLength={3}
                        onChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, cstIbsCbsPadrao: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
                <div className="col-12 mb-3">
                    <Label>Classificação tributária padrão</Label>
                    <InputText value={classificacaoFiscal.classificacaoTributariaPadrao ?? ""} maxLength={6}
                        onChange={(e) => { setClassificacaoFiscal({ ...classificacaoFiscal, classificacaoTributariaPadrao: e.target.value }); setErro(""); }}
                        style={{ width: "100%" }} />
                </div>
            </div>
            {erro && <small className="p-error">{erro}</small>}
        </BaseCadastro>
    );
}
